import ChatApp from './chat/ChatApp';
import ChatUI from './ui/ChatUI';
import SwinglyChatData from './data/SwinglyChatData';

// Initialize the application
document.addEventListener('DOMContentLoaded', async () => {
    try {
        // Create chat app instance
        // const chatDataProvider = new SwinglyChatData();
        const chatApp = new ChatApp();
        const chatUI = new ChatUI(chatApp);
        
        // Wait for chat to initialize (including groups loading)
        await chatApp.initialize();
        
        // Then render the UI
        chatUI.renderContactsList();
        chatUI.initializeUIEvents();
        
        // Finally set up chat handlers after UI is rendered
        chatApp.setupChatHandlers();
    } catch (error) {
        console.error('Failed to initialize:', error);
    }
}); 